import { useEffect } from 'react'
import { GridCellProps } from '@progress/kendo-react-grid'
import { generateClassNameForReverseType } from 'helpers/transactions'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchCountriesAction } from 'store/identity/identity.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { IdentityApiClient } from 'utils/api/identityApi'
import { isEmpty } from 'utils/is-empty'

const CountryCell = (props: GridCellProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const identityApiClient = useApiClient(IdentityApiClient)
  const countries = useAppSelector((state) => state.identity.countries)

  useEffect(() => {
    if (isEmpty(countries)) {
      dispatch(fetchCountriesAction(identityApiClient))
    }
  }, [dispatch, countries])

  const dataItem = props.dataItem
  const countryCode =
    dataItem.walletTransactions?.[0]?.paymentProviderTransaction?.request?.user_country_id
  const country = countries.find((c) => c.id === countryCode)

  return <td className={generateClassNameForReverseType(dataItem)}>{country?.name ?? '-'}</td>
}

export default CountryCell
